export const sapProgramKeys = {
  all: ["sapProgram"] as const,
  program: (programId: string) => [...sapProgramKeys.all, programId] as const,
  query: (queryParam: Record<string, string>) => [...sapProgramKeys.all, queryParam] as const,
};
